@if (coverDetails$ | async) {
  <lib-cover
    [imageSize]="$safeNavigationMigration((coverDetails$ | async)?.size)"
    [ngStyle]="{ 'height.px': currentHeight$ | async }"
    [point]="$safeNavigationMigration((coverDetails$ | async)?.point)"
    [url]="$safeNavigationMigration((coverDetails$ | async)?.url)"
  ></lib-cover>
}
